module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-select', {
    attrs: {
      "single-line": "",
      "solo": "",
      "flat": "",
      "persistent-hint": "",
      "items": _vm.types,
      "hint": _vm.typeHint,
      "hide-details": _vm.hideHint,
      "append-outer-icon": _vm.customIcon,
      "disabled": _vm.isReadOnly,
      "item-text": "label",
      "item-value": "value"
    },
    on: {
      "click:append-outer": _vm.custom
    },
    model: {
      value: (_vm.type),
      callback: function($$v) {
        _vm.type = $$v
      },
      expression: "type"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0490c2b9","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ScheduleType.vue
// module id = 394
// module chunks = 1